import { useEffect, useState } from 'react';
import { Container, Header } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { EPICS_PATH_CONTINUE } from 'volto-epics-addon/constants';
import { TASK_UPLOAD_PROMPT } from 'volto-base-addon/constants';
import { completeTask, useTask } from 'volto-epics-addon/helpers';
import UploadStepsContainer from 'volto-base-addon/components/theme/FileUpload/UploadStepsContainer';
import {
  MEDIA_FILE_AUDIO_TYPES,
  MEDIA_FILE_VIDEO_TYPES,
} from 'volto-base-addon/constants/MediaFileMimeTypes';
import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import { Dashboard } from '@uppy/react';
import Webcam from '@uppy/webcam';
import Audio from '@uppy/audio';
import ScreenCapture from '@uppy/screen-capture';
import Uppy from '@uppy/core';
import XHRUpload from '@uppy/xhr-upload';
import Finnish from '@uppy/locales/lib/fi_FI';
import English from '@uppy/locales/lib/en_US';

import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  helmetTitle: {
    id: 'helmetTitleUploadPrompt',
    defaultMessage: 'Media File Upload',
  },
  mediaUploadHeader: {
    id: 'mediaUploadHeader',
    defaultMessage: 'Media upload',
  },
  mustLoginFirst: {
    id: 'mustLoginFirst',
    defaultMessage: 'You must log in first.',
  },
});

const Page = () => {
  const history = useHistory();
  const intl = useIntl();
  const task = useTask(TASK_UPLOAD_PROMPT);
  const token = useSelector((state) => state.userSession.token);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [uppy, setUppy] = useState(null);
  const lang = useSelector((state) => state.intl.locale);
  const destinationTitle = task?.variables?.destinationTitle;

  useEffect(() => {
    setIsAuthenticated(!!token);
    setIsVisible(true);
  }, [token]);

  useEffect(() => {
    if (task?.completed === true) {
      history.push(EPICS_PATH_CONTINUE);
    }
  }, [task, history]);

  useEffect(() => {
    const uppy = new Uppy({
      restrictions: {
        maxNumberOfFiles: 1,
        allowedFileTypes: MEDIA_FILE_AUDIO_TYPES.concat(MEDIA_FILE_VIDEO_TYPES),
      },
      locale: lang === 'fi' ? Finnish : English,
    })
      .use(Webcam)
      .use(Audio)
      .use(ScreenCapture, {
        displayMediaConstraints: {
          video: {
            width: { ideal: 1920, max: 1920 },
            height: { ideal: 1080, max: 1080 },
            frameRate: { ideal: 30 },
          },
          audio: true,
        },
        preferredVideoMimeType: 'video/webm',
      });
    uppy.use(XHRUpload, {
      endpoint: null,
      method: 'PUT',
      formData: false,
      getResponseData: () => {
        return { url: '' };
      },
    });
    uppy.on('complete', (result) => {
      if (result.failed.length === 0) {
        const fname = result.successful[0].name;
        completeTask(TASK_UPLOAD_PROMPT, { filename: fname });
      }
    });
    setUppy(uppy);
  }, [lang]);

  useEffect(() => {
    if (!uppy) return;
    uppy.getPlugin('XHRUpload').setOptions({
      endpoint: task?.variables?.presignedUploadUrl,
    });
  }, [task, uppy]);

  return (
    <div>
      <Helmet>
        <title>{intl.formatMessage(messages.helmetTitle)}</title>
      </Helmet>
      {isVisible ? (
        isAuthenticated ? (
          <>
            <UploadStepsContainer currentStep={1} totalSteps={4} />
            <Header
              style={{
                margin: '1em auto',
                display: 'block',
                textAlign: 'center',
              }}
            >
              {intl.formatMessage(messages.mediaUploadHeader)}
            </Header>
            <Container className="file-upload-prompt-container">
              <p>{destinationTitle}</p>
              {!task?.variables?.presignedUploadUrl ? (
                <></>
              ) : (
                <Dashboard
                  uppy={uppy}
                  doneButtonHandler={null}
                  proudlyDisplayPoweredByUppy={false}
                ></Dashboard>
              )}
            </Container>
          </>
        ) : (
          <Container className="file-upload-prompt-container">
            <Header> {intl.formatMessage(messages.mustLoginFirst)} </Header>
          </Container>
        )
      ) : (
        <Container className="file-upload-prompt-container"></Container>
      )}
    </div>
  );
};

export default Page;
